import { createContext, useContext, useEffect, useState } from 'react';
import { getByDashboard12PeriodsId } from '../../../../Core/Service/ManageAccount/maDash12M-service';
import moment from 'moment';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { getAccountCodeData, getServDashScreenByCode } from '../../../../Core/Service/ManageAccount/servDash-service';
import AppContext from '../../../../App/AppContext';
import { react } from '@babel/types';

export const ManageAccount12MonthsContext = createContext();
const get12MonthList = (obj) => {
    let monthListArray = [];
    let startMonth = obj.startPeriod;
    let startYear = obj.startYear;
    let startDate = moment().year(startYear).month(startMonth);

    for (let i = 0; i < 12; i++) {
        const monthStr = startDate
            .clone()
            .add(i - 1, 'months')
            .format('MMM YYYY');
        const period = moment(startDate).add(i, 'months').month();
        monthListArray.push({ name: monthStr, id: period === 0 ? 12 : period });
    }

    return monthListArray;
};

export const ManageAccount12MonthsProvider = (props) => {
    const portalSettings = AppStorage.getPortalSetting();
    const { showToast } = useContext(AppContext);

    const [state, setState] = useState({
        dashboardMenus: [],
        getUniqueNameList: [],
        getNameList: [],
        Category: [],
        showLoader: false,
        bgColor: '',
        txtColor: '',
        screenLoader: true
    });
    const [dashboardID, setDashboardID] = useState(+AppStorage?.getMAdashboardSavedID() || portalSettings?.portalSettingDefaultDashboardID || null);

    const [months, setMonths] = useState([]);
    const [accountCodes, setAccountCodes] = useState([]);

    const [accountData, setAccountData] = useState({
        period: '',
        catName: '',
        mainCat: ''
    });

    const fetchDashboardData = async () => {
        const response = await getByDashboard12PeriodsId(dashboardID);
        if (response.success) {
            setState((st) => ({ ...st, showLoader: true }));
            const { dashboards, dashboardData, periods } = response.data;
            const sortedList = dashboardData.sort((a, b) => a.sequence - b.sequence);
            const uniqueNames = [...new Set(sortedList.map((item) => item.maMappingCategoryName))];
            let monthList = get12MonthList(periods[0] || {});
            setState((prev) => ({ ...prev, dashboardMenus: dashboards, getNameList: sortedList, getUniqueNameList: uniqueNames }));
            setMonths((prev) => monthList);
            setState((st) => ({ ...st, showLoader: false, screenLoader: false }));
        }
    };

    let fetchData = async () => {
        try {
            if (dashboardID) {
                let res = await getServDashScreenByCode(dashboardID);
                if (res.success) {
                    let flagData = res?.data?.dashboard[0] || {};
                    setState((st) => {
                        return {
                            ...st,
                            bgColor: flagData.bgColor || '#000000',
                            txtColor: flagData.txtColor || '#ffffff',
                            name: flagData.name || '',
                            Category: res?.data?.categorytemplate || []
                        };
                    });
                }
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    useEffect(() => {
        let list = [];
        if (state?.Category?.length > 0 && state?.getNameList?.length > 0) {
            state?.Category?.forEach((cat) => {
                let getNameList = state.getNameList.filter((item) => item.maMappingCategoryID === cat.id);
                list.push({ ...cat, getNameList });
            });
        }
    }, [state?.Category, state?.getNameList]);

    useEffect(() => {
        if (dashboardID) {
            fetchData();
            fetchDashboardData();
        }
    }, [dashboardID]);

    const dashboardIDHandler = (id) => {
        setDashboardID(id);
        setState((st) => ({ ...st, showLoader: true }));
    };

    const handleAccountCodes = () => {
        setState((st) => ({ ...st, openAccountCodes: !st.openAccountCodes }));
    };

    let getOverallAccountCodeData = async (catID, maMappingCategoryName, mainCat, period) => {
        if (state.branchNewList.length > 0) {
            let res = await getAccountCodeData(catID, state.period, state.yearID);
            if (res.success) {
                setAccountCodes(res?.data?.table || []);
                setAccountData((st) => ({ ...st, period: period, catName: maMappingCategoryName, mainCat: mainCat }));
                handleAccountCodes();
            } else {
                for (let key in res.errors) {
                    if (res.errors.hasOwnProperty(key)) {
                        showToast(`${key}: ${res.errors[key].join(', ')}`);
                    }
                }
                setAccountCodes([]);
                setAccountData((st) => ({ ...st, period: '', catName: '', mainCat: '' }));
            }
        }
    };

    const extractUsedCategoryIds = (calculation) => {
        try {
            if (typeof calculation !== 'string') return [];

            const matches = [...calculation.matchAll(/#(\d+)#/g)];
            return matches.map((m) => Number(m[1])).filter((n) => !isNaN(n));
        } catch (error) {
            console.error('Error extracting category IDs:', error);
            return [];
        }
    };

    const getNumericKeys = (obj) => Object.keys(obj).filter((key) => key !== 'maDashboardCategoryId' && typeof obj[key] === 'number');

    const groupBy = (arr, key) =>
        arr.reduce((acc, item) => {
            const val = item[key];
            if (!acc[val]) acc[val] = [];
            acc[val].push(item);
            return acc;
        }, {});

    function calculateGroupedDataUsingFormula(data, formula, resultCategoryId) {
        const finalResult = [];

        const uniqueKeys = [];
        data.forEach((item) => {
            const key = `${item.year}|${item.period}|${item.maMappingCategoryName}`;
            if (!uniqueKeys.includes(key)) uniqueKeys.push(key);
        });

        uniqueKeys.forEach((key) => {
            const [year, period, name] = key.split('|');
            const yearNum = +year;
            const periodNum = +period;

            const filtered = data.filter((item) => item.year === yearNum && item.period === periodNum && item.maMappingCategoryName === name);

            console.log(filtered, 'filtered data for', name, 'in year', yearNum, 'and period', periodNum);

            const categoryMap = {};
            filtered.forEach((item) => {
                categoryMap[item.maDashboardCategoryId] = item.actual;
            });

            const expression = formula.replace(/#(\d+)#/g, (_, id) => {
                const val = categoryMap[+id] != null ? categoryMap[+id] : 0;
                return val;
            });

            let actualValue = null;
            try {
                actualValue = new Function(`return (${expression})`)();
            } catch (e) {
                console.warn(`Failed to evaluate formula for ${name} ${year}-${period}:`, e.message);
            }

            if (actualValue !== null) {
                finalResult.push({
                    year: yearNum,
                    period: periodNum,
                    maMappingCategoryName: name,
                    mappingCategoryID: resultCategoryId,
                    actual: actualValue
                });
            }
        });

        return finalResult;
    }

    const getCalculatedData = (groupedData, calculation, categoryId) => {
        const usedCategoryIds = extractUsedCategoryIds(calculation);
        const filteredData = groupedData.filter((item) => usedCategoryIds.includes(item.maDashboardCategoryId));

        if (filteredData.length === 0) return [];

        const groupedByCategoryName = filteredData;

        let result = calculateGroupedDataUsingFormula(groupedByCategoryName, calculation, categoryId);
        return result;
    };

    const getCalculateData = (isCalculation, calculation, categoryId) => {
        const groupedData = state.getNameList;

        if (isCalculation) {
            return getCalculatedData(groupedData, calculation, categoryId).sort((a, b) => a.sequence - b.sequence);
        }
        return [];
    };

    return (
        <ManageAccount12MonthsContext.Provider value={{ state, dashboardIDHandler, dashboardID, months, getCalculateData }}>
            {props.children}
        </ManageAccount12MonthsContext.Provider>
    );
};
